import cookieParser from 'cookie'
import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'

import { BEARER_TOKEN_COOKIE } from 'interfaces/constants'

import atob from '../atob'

export const getUserIdFromCookie = (reqCookie?: string) => {
  const parsedCookie = cookieParser.parse(reqCookie || '')
  const reqToken = parsedCookie[BEARER_TOKEN_COOKIE]
  const token = reqToken || Cookies.get(BEARER_TOKEN_COOKIE) || ''

  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )

    return JSON.parse(jsonPayload).sub
  } catch (err) {
    return ''
  }
}

export const getUserInfoFromCookie = (reqCookie?: string) => {
  const parsedCookie = cookieParser.parse(reqCookie || '')
  const reqToken = parsedCookie[BEARER_TOKEN_COOKIE]
  const token = reqToken || Cookies.get(BEARER_TOKEN_COOKIE) || ''

  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )
    const payload = JSON.parse(jsonPayload)
    return { email: payload.email, id: payload.sub }
  } catch (err) {
    return { email: '', id: 0 }
  }
}

export const getHhgIdFromCookie = (reqCookie?: string) => {
  const parsedCookie = cookieParser.parse(reqCookie || '')
  const reqHhgId = parsedCookie['hhg-id']

  return reqHhgId || Cookies.get('hhg-id') || ''
}

export const getSubotCookieId = (queryCookieId?: string) => {
  if (queryCookieId) {
    Cookies.set('hhg-id', queryCookieId)
    return queryCookieId
  }

  const cookieId = getHhgIdFromCookie()

  if (cookieId) {
    return cookieId
  }

  const newCookieId = uuidv4()
  Cookies.set('hhg-id', newCookieId)
  return newCookieId
}
